import React from 'react'

const ChatIconBg = props => {
  return (
    <svg
      className={props.classProp}
      style={{ position: 'absolute', top: '40px', left: '40px' }}
      xmlns="http://www.w3.org/2000/svg"
      width="385"
      height="358"
      viewBox="0 0 385 358"
    >
      <g fill="none" fill-rule="evenodd" opacity=".076">
        <path
          d="M75.083 273.433c.645 37.923-7.146 53.974-21.615 83.768 58.513-16.867 94.384-17.636 134.747-83.768h160.772c19.646 0 35.698-16.094 35.698-35.743V35.699c0-19.606-16.052-35.7-35.697-35.7H36.305C16.656-.001.608 16.093.608 35.699V239.275c.855 18.919 16.564 34.158 35.697 34.158h38.778z"
          fill="#FBFBFB"
        />
        <path
          d="M111.769 83.458H77.055c-8.34 0-15.102-6.761-15.102-15.101s6.762-15.099 15.102-15.099h34.714c8.34 0 15.101 6.759 15.101 15.099s-6.761 15.101-15.101 15.101m196.47 0H187.275c-8.34 0-15.101-6.761-15.101-15.101s6.761-15.099 15.101-15.099h120.962c8.34 0 15.102 6.759 15.102 15.099s-6.762 15.101-15.102 15.101M308.24 151.817H77.055c-8.34 0-15.101-6.761-15.101-15.101s6.761-15.099 15.101-15.099H308.24c8.34 0 15.102 6.758 15.102 15.099 0 8.34-6.761 15.101-15.102 15.101M198.019 220.174H77.057c-8.34 0-15.102-6.761-15.102-15.101s6.762-15.099 15.102-15.099h120.962c8.34 0 15.101 6.759 15.101 15.099s-6.761 15.101-15.101 15.101m110.221 0h-34.717c-8.34 0-15.098-6.761-15.098-15.101s6.758-15.099 15.098-15.099h34.717c8.34 0 15.098 6.759 15.098 15.099s-6.758 15.101-15.098 15.101"
          fill="#2A779A"
        />
      </g>
    </svg>
  )
}

export default ChatIconBg
